import { isArray, isNil } from 'lodash';
import { Weekday } from 'rrule';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { Batch } from '@shared/scenes/cards/entityBulkActions/BatchCreateContext/BatchContext';
import { Colors, grid } from '@shared/styles';
import { useIsDesktop } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';
import { DaysOfWeek, buildCustomRRule } from './utils';

export function WeekOptions({
  rruleOptions,
  setRruleOptions,
}: Pick<Batch, 'rruleOptions' | 'setRruleOptions'>) {
  const isDesktop = useIsDesktop();

  const setDayOfWeek = (day: Weekday, isDaySelected: boolean) => {
    setRruleOptions(prev => {
      const prevByweekday =
        !isNil(prev) && !isNil(prev?.byweekday) ? (prev.byweekday as Weekday[]) : [];
      const newByweekday =
        isNil(prev) || isNil(prev?.byweekday)
          ? []
          : [...prevByweekday.filter(d => d.weekday !== day.weekday)];
      if (!isDaySelected) {
        newByweekday.push(day);
      }

      return buildCustomRRule(prev, {
        byweekday: newByweekday,
      });
    });
  };

  return (
    <View gap={1}>
      <Text size="body1" weight="semibold">
        {i18n('workflowTemplate.component.dateAndRepeat.onDotDotDot')}
      </Text>
      <View
        row
        centerVertically
        paddingVertical={isDesktop ? 1 : 2}
        style={{ justifyContent: 'space-between' }}
      >
        {DaysOfWeek.map((weekday: Weekday, index: number) => {
          const isDaySelected =
            !isNil(rruleOptions) &&
            isArray(rruleOptions?.byweekday) &&
            rruleOptions?.byweekday?.includes(weekday);
          return (
            <MBTouchableOpacity
              key={weekday.toString()}
              onPress={() => setDayOfWeek(weekday, isDaySelected)}
              style={[
                {
                  borderRadius: isDesktop ? 32 : 40,
                  borderWidth: 1,
                  borderColor: Colors.v2.purple,
                  width: isDesktop ? 31 : 40,
                  height: isDesktop ? 31 : 40,
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginHorizontal: grid(0.5),
                  marginLeft: index === 0 ? 0 : grid(0.5),
                  marginRight: index === DaysOfWeek.length - 1 ? 0 : grid(0.5),
                },
                isDaySelected && { backgroundColor: Colors.v2.purple },
              ]}
            >
              <Text
                size="body2"
                style={{ fontSize: 14, color: isDaySelected ? Colors.v2.white : Colors.v2.purple }}
              >
                {weekday.toString()}
              </Text>
            </MBTouchableOpacity>
          );
        })}
      </View>
    </View>
  );
}
